import * as R from 'ramda';
import React, { useState } from 'react';
import copyTo from './copyTo';
import initAmendment from './initAmendment';

// "Dupliqué" dans SPID Client sans la partie avenant
const useObjectiveCategories = ({
  college,
  offerType,
  ccn,
  collegeIsSelected,
  selectedCategories,
  setSelectedCategories,
  courseIsAmendment,
  isKnownAmendment
}) => {
  const [formerSelectedCategories] = useState(selectedCategories);
  const displayObjectiveCategoriesSelection =
        !R.pathSatisfies(R.isNil, [offerType, 'objectiveCategories', college])(ccn) // Le collège a des catégories objectives
        && collegeIsSelected;

  const getObjectiveCategoriesForCollege = college => R.pathOr([], [offerType, 'objectiveCategories', college], ccn);
  const objectiveCategories = getObjectiveCategoriesForCollege(college);

  const objectiveCategoryIsSelected = objectiveCategory => R.pathEq([college, 'objectiveCategory', 'option'], objectiveCategory.option, selectedCategories);

  const setObjectiveCategoryForCollege = (college, objectiveCategory) => setSelectedCategories(R.assocPath([college, 'objectiveCategory'], objectiveCategory));
  const removeObjectiveCategoryForCollege = college => setSelectedCategories(R.dissocPath([college, 'objectiveCategory']));
  const setObjectiveCategory = objectiveCategory => setObjectiveCategoryForCollege(college, objectiveCategory);
  const removeObjectiveCategory = () => removeObjectiveCategoryForCollege(college);

  const updateObjectiveCategory = objectiveCategory => {
    if (courseIsAmendment && isKnownAmendment) {
      const formerObjectiveCategory = R.path([college, 'objectiveCategory'], formerSelectedCategories);

      if (!R.isNil(formerObjectiveCategory)) {
        return;
      }
    }

    let select = true;

    if (R.isNil(objectiveCategory) || objectiveCategoryIsSelected(objectiveCategory)) {
      // Désélection
      select = false;
      removeObjectiveCategory();
    } else {
      // Sélection
      setObjectiveCategory(objectiveCategory);
    }

    copyTo({ selectedCategories, college, objectiveCategory, select, setObjectiveCategoryForCollege, removeObjectiveCategoryForCollege, getObjectiveCategoriesForCollege });
  };

  React.useEffect(() => {
    if (!collegeIsSelected) {
      removeObjectiveCategory();
    }
  }, [collegeIsSelected]);

  initAmendment({
    courseIsAmendment,
    isKnownAmendment,
    selectedCategories,
    getObjectiveCategoriesForCollege,
    setObjectiveCategoryForCollege
  });

  return {
    displayObjectiveCategoriesSelection,
    objectiveCategories,
    objectiveCategoryIsSelected,
    updateObjectiveCategory
  };
};

export default useObjectiveCategories;
